import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "EquipmentHierarchys"; //Api has a typo

export interface GetHierarchyListParams {
  equipment: string
}

export const getEquipmentHierarchyList = async (params: GetHierarchyListParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetHierarchyList`,
    undefined,
    params
  );
};

export interface GetHierarchyParams {
  parent: string;
  parentType: number;
  onlyItem?: boolean;
}

/**
 * Fetches one level of the hierarchy: the parent node plus its immediate
 * children. Every child carries ChildrenExists, so an expander can be drawn
 * without fetching that child's level first.
 *
 * Prefer this over getEquipmentHierarchyList: GetHierarchyList returns the
 * entire flattened subtree, which on a large plant is tens of MB and, because
 * eq_hierarchy is a DAG rather than a tree, expands combinatorially on the
 * client. This is the endpoint EAM Web uses.
 */
export const getHierarchy = async (params: GetHierarchyParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetHierarchy`,
    undefined,
    params
  );
};
